var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalAndRegulatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5L19.383 15.918C20.206 16.738 20.206 18.066 19.383 18.885C18.9876 19.2783 18.4527 19.499 17.895 19.499C17.3373 19.499 16.8024 19.2783 16.407 18.885L9 11.5M12 8.5L8 4.5M12 8.5L12.5 9.00009L14.793 6.70709C14.9804 6.51957 15.0858 6.26526 15.0858 6.00009C15.0858 5.73493 14.9804 5.48062 14.793 5.29309L11.207 1.70709C11.0194 1.51962 10.7651 1.41431 10.5 1.41431C10.2348 1.41431 9.9805 1.51962 9.79297 1.70709L7.49997 4.00009L8 4.5M12 8.5L9 11.5M9 11.5L5 7.5M9 11.5L9.49997 12.0001L7.20697 14.2931C7.01944 14.4806 6.76514 14.5859 6.49997 14.5859C6.23481 14.5859 5.9805 14.4806 5.79297 14.2931L2.20697 10.7071C2.0195 10.5196 1.91418 10.2653 1.91418 10.0001C1.91418 9.73493 2.0195 9.48062 2.20697 9.29309L4.49997 7.00009L5 7.5M5 7.5L8 4.5M2 19.5H9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalAndRegulatory);
export default __webpack_public_path__ + "static/media/legal_and_regulatory.a3f4224246c9841a851ca7bb759f6b83.svg";
export { ForwardRef as ReactComponent };